// export this package's api
import Align from "./Align";
export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-select/node_modules/rc-align/es/index.js
// module id = 1293
// module chunks = 0